/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
    RepeatableScreensManager,
    RepeatableScreensManagerDeps
} from '../../../pages/shared/step/repeatable-screen-manager.class';
import {UserModelListService} from '../../../domain/model/common/user-model-list.service';
import {NavigableNode} from '../service/navigable-node.class';

@Injectable()
export abstract class RepeatableUserModelScreensManager extends RepeatableScreensManager {

    protected abstract readonly _modelService: UserModelListService<any>;

    constructor(rsmm: RepeatableScreensManagerDeps) {
        super(rsmm);
    }

    init(parent: NavigableNode<any, any>) {
        super.init(parent);
        this._modelService.changes$.switchMap(() => this.refresh()).subscribe(() => {});
    }

    protected _countEntries(): Observable<number> {
        return this._modelService.countCurrentUserModelEntries();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/sections/repeatable/repeatable-user-model-screens-manager.service.ts